import React from 'react'
import Pagination from 'react-js-pagination'
import { connect } from 'react-redux'
import AdvancedTable from '../../Components/AdvancedTable'
import AttractionActions from '../../Redux/AttractionRedux'
import DestinationActions from '../../Redux/DestinationRedux'

class NewAttractionCreateMapping extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      searchData: {
        limit: 10,
        q: '',
        c: '',
        provider: '',
        page: 1
      },
      targetDestination: '',
      selectedArray: []
    }
    this.providerSelector = [
      { label: 'ALL', value: '' },
      { label: 'BMG', value: 'BMG' },
      { label: 'KLOOK', value: 'KLOOK' },
      { label: 'LOKET', value: 'LOKET' }
    ]
  }

  _manipulateSearchData = (event, field) => {
    event && event.preventDefault()
  }

  _setAttraction = (item, context) => {
    let set = new Set(this.state.selectedArray)
    switch (context) {
      case 'select':
        set.add(item)
        break
      case 'deselect':
        set.delete(item)
        break
      default:
        return null
    }
    let selectedArray = [...set]
    this.setState({ selectedArray })
  }

  _contextButton = (item, context) => {
    switch (context) {
      case 'select':
        return (
          <button className='btn btn-info' onClick={() => this._setAttraction(item, 'select')}>
            Select
          </button>
        )
      case 'deselect':
        return (
          <button className='btn btn-danger' onClick={() => this._setAttraction(item, 'deselect')}>
            Remove
          </button>
        )
      default:
        return null
    }
  }

  _handleChangePage = (page) => {
    let searchData = this.state.searchData
    searchData.page = page
    this.setState({ searchData })
    this.props.searchPlace(searchData)
  }

  _handleSearchSubmit = (e) => {
    e.preventDefault()
    let data = { ...this.state.searchData }
    data.page = 1
    this.props.searchPlace(data)
  }

  _handleChange = (e, field) => {
    let value = e.target.value
    let searchData = { ...this.state.searchData }
    searchData[field] = value
    this.setState({ searchData })
  }

  _applyTo = (e) => {
    let targetDestination = e.target.value
    this.setState({ targetDestination })
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    let selectedArray = this.state.selectedArray
    let places = []
    selectedArray.map((item, i) => (
      places[i] = { type: item.place_type, id: item.id }
    ))
    let data = {
      destination_id: this.state.targetDestination,
      places
    }
    this.props.savePlace(data)
    this.props._close()
  }

  render () {
    const { attraction, destination } = this.props
    return (
      <section className='section' style={{ width: '90vw' }}>
        <div className='title-block'>
          <h1 className='title'>
            Create Mapping
            {
              (attraction.fetching || attraction.processing) &&
              <div className='badge badge-info ml-2'>Loading ...</div>
            }
          </h1>
        </div>
        <div className='row'>

          {/* LEFT HAND SIDE SECTION */}
          <section className='col-xs-12 col-sm-6'>
            <div className='title-block'>
              <h5 className='text-left'>Search Attraction</h5>
            </div>
            <form onSubmit={(x) => this._handleSearchSubmit(x)}>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Title</label>
                </div>
                <div className='col-9'>
                  <input placeholder='Search by Title' className='form-control' type='text' onChange={(e) => this._handleChange(e, 'q')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>City</label>
                </div>
                <div className='col-9'>
                  <input placeholder='Search by City' className='form-control' type='text' onChange={(e) => this._handleChange(e, 'c')} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-3'>
                  <label className='control-label'>Provider</label>
                </div>
                <div className='col-9'>
                  <select className='form-control' onChange={(e) => this._handleChange(e, 'provider')}>
                    {
                      this.providerSelector.map((option, i) => (
                        <option key={i} value={option.value}>{option.label}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className='form-group d-flex justify-content-end'>
                <button type='submit' className='btn btn-primary'><i className='fa fa-search' /> Search</button>
              </div>
            </form>
            <AdvancedTable
              colSpan={4}
              header={[
                { field: 'Title' },
                { field: 'City' },
                { field: 'Provider' },
                { field: 'Action' }
              ]}
              body={
                attraction.dataSearch.data &&
                attraction.dataSearch.data.length > 0 &&
                attraction.dataSearch.data.map((item) => ([
                  { field: item.title },
                  { field: item.city.name },
                  { field: item.provider },
                  { field: this._contextButton(item, 'select') }
                ]))
              }
            />
            <div className='text-center'>
              <Pagination
                innerClass='pagination'
                itemClass='page-item'
                linkClass='page-link'
                activePage={attraction.dataSearch.page}
                itemsCountPerPage={10}
                totalItemsCount={attraction.dataSearch.total}
                pageRangeDisplayed={5}
                onChange={this._handleChangePage}
              />
            </div>
          </section>

          {/* RIGHT HAND SIDE SECTION */}
          <section className='col-xs-12 col-sm-6'>
            <div className='title-block'>
              <h5 className='text-left'>Selected Attraction</h5>
            </div>
            <div className='selected-list'>
              <AdvancedTable
                colSpan={4}
                header={[
                  { field: 'Title' },
                  { field: 'City' },
                  { field: 'Provider' },
                  { field: 'Action' }
                ]}
                body={
                  this.state.selectedArray.map((item) => ([
                    { field: item.title },
                    { field: item.city.name },
                    { field: item.provider },
                    { field: this._contextButton(item, 'deselect') }
                  ]))
                }
              />
            </div>
            <div className='form-group row'>
              <div className='col-3'>
                <label className='control-label'>Apply to:</label>
              </div>
              <div className='col-9'>
                <select className='form-control' defaultValue='DEFAULT' onChange={(e) => this._applyTo(e)}>
                  <option disabled value='DEFAULT'>- Please select a destination -</option>
                  {
                    destination.data &&
                    destination.data.map((item, i) => (
                      <option key={i} value={item.id}>{item.name}</option>
                    ))
                  }
                </select>
              </div>
            </div>
          </section>
        </div>
        <div className='form-group d-flex justify-content-end'>
          <button className='btn btn-lg btn-secondary mr-2' onClick={this.props._close}>Close</button>
          <button className='btn btn-lg btn-primary mr-2' onClick={(e) => this._handleSubmit(e)}>Save</button>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction,
  destination: state.destination
})

const dispatchToProps = (dispatch) => ({
  searchPlace: (data) => dispatch(AttractionActions.placeSearchRequest(data)),
  savePlace: (data) => dispatch(DestinationActions.addPlaceToDestinationRequest(data))
})

export default connect(stateToProps, dispatchToProps)(NewAttractionCreateMapping)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/NewAttractionCreateMapping.js